<template>
  <div class="pageSize">
    <el-pagination
      background
      layout="prev, pager, next"
      :total="total"
      :page-size="pageSize"
      :current-page="currentPage"
      :hide-on-single-page="true"
      @current-change="currentChange"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: 'pagination',
  // props: ['total', 'pageSize', 'currentChange']
  props: {
    total: {
      type: Number,
      default: 8
    },
    pageSize: {
      type: Number,
      default: 1
    },
    currentChange: {
      type: Function
    },
    currentPage: {
      type: Number,
      default: 1
    }
  }
}
</script>

<style lang="scss" scoped>
.pageSize{
  width: 100%;
  margin: 20px 0px 40px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/pagination.vue